import { useCallback, useEffect } from 'react';
import { useIsMobile } from '~/components/Breakpoint/Breakpoint.hook';
import { isVault } from '~/components/Dosi/Vault';
import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';
import { openPopupCenter } from '~/components/Util';

const DOSI_URL = import.meta.env.VITE_DOSI_URL;

// TODO: Only needed if store provided through embedded viewer
export const SellPopupPostMessage = () => {
  const { close } = useEmbeddedViewer();
  const isMobile = useIsMobile();

  const handleMessage = useCallback(
    (event: MessageEvent) => {
      if (event.origin !== DOSI_URL) {
        return;
      }

      const message = event.data;
      if (message.type === 'SELL_POPUP_OPEN') {
        const url = message?.data?.url;
        if (url) {
          close();
          const newWindow = openPopupCenter(url, 'SELL_POPUP_OPEN', { width: 600, height: 700 });

          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            window.location.href = url;
          }
        }
      }
    },
    [close]
  );

  useEffect(() => {
    if (!isVault && !isMobile) {
      window.addEventListener('message', handleMessage);
      return () => window.removeEventListener('message', handleMessage);
    }
  }, [close, handleMessage, isMobile]);

  return null;
};
